





















import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "RightNav",
  components: {}
})
export default class RightNav extends Vue {
  private ulOpen = true;
  private style: any = {};
  private init = false;

  private mounted() {
    this.autoPosition();
  }

  /**
   * 自动计算头部高度和右边距样式
   */
  private autoPosition() {
    const bodyStart: HTMLElement | null = document.querySelector("#body-start");

    if (bodyStart) {
      const right = Math.floor((window.innerWidth - bodyStart.clientWidth) / 2);

      // this.$set(this.style, "right", `${right - 80 }px`);
      this.style = {
        right: `${right > 80 ? right - 80 : 10}px`,
        top: `${bodyStart.offsetTop}px`
      };
      this.init = true;
    }
  }
}
